// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';


type Props = {
  when: boolean,
  message: string | (location: Object) => (string | boolean),
  router: Object,
  route?: {
    path: string,
    __id__: number,
  },
}

class PromptRouter3 extends Component<Props> {
  componentDidMount() {
    const { router, route } = this.props;
    router.setRouteLeaveHook(route, this.routerWillLeave.bind(this));
  }

  routerWillLeave(nextLocation) {
    const { when, message } = this.props;
    if (when) {
      if (typeof message === 'function') {
        return message(nextLocation);
      }
      return message;
    }
    return true;
  }

  render() {
    return (<span />);
  }
}

export default withRouter(PromptRouter3);
